import Vue from 'vue';
import Vuex from 'vuex';
import { deviceType } from "mobile-device-detect";
import bgm from "@/store/bgm";
import contents from "@/store/contents";

Vue.use(Vuex);

// MatterportのSDK Key
const matterportSDKKey: string = 'mws1yasidd5hmthy9x7q47f6d';

// テストサイト公開時のPublicPath
const prodPublicPath: string = 'https://archive-27.matium.jp';
// 本番公開時のPublicPath
// const prodPublicPath: string = '/sonoaida';

export default new Vuex.Store({
  state: {
    // SDK Key
    matterport_sdk_key: matterportSDKKey,
    // サイトの公開パス
    publicPath: process.env.NODE_ENV === 'production' ? prodPublicPath : '',
    // スマートフォンデバイス
    isSmp: deviceType === 'mobile',
    // タブレットデバイス
    isTablet: deviceType === 'tablet'
  },
  mutations: {
  
  },
  actions: {
  
  },
  modules: {
    bgm,
    contents
  }
});
